//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { getSortLabel } from '@utils/gaUtils';
import dropdownTemplate from '@partials/dropdown.html';

(function() {
    /** The height (in pixels) of each dropdown element.  It is safe to hard-code this height since dropdown options only come in one size.
     * If that ever changes then we'll need to do something fancier here, like querying the DOM to get the option height.
     */
  const OPTION_HEIGHT_PX = 24;
  const ENTER_KEY = 13;

  angular.module('curalate')
        /*
         * dropdown is a common component that exposes a styled dropdown menu that invokes a callback function when a new value is selected.
         *
         * @attr trackingCategory   The string used for any TrackingService calls
         * @attr default            (Optional) The default option to display on pageload.  If unspecified, we use the first option in the list.
         * @attr optionChange       The callback function within the parent scope that should be invoked when a new option is selected.
         */
        .directive('dropdown',
            () => ({
              restrict: 'E',
              transclude: true,
              scope: {
                default: '=',
                lazyDefault: '@?',
                disabled: '=ngDisabled',
                optionChange: '&',
                name: '=dropdownName',
                buttonKlass: '@buttonClass',
                height: '=',
                trackingCategory: '@?',
                isRight: '=',
              },
              template: dropdownTemplate,
              controller: ['$element', '$scope', '$timeout', 'TrackingService', function($element, $scope, $timeout, TrackingService) {
                const defaultOption = $scope.default;
                const that = this;

                $scope.options = [];
                $scope.model = {};

                this.$onInit = function() {
                  this.trackOnBrandSort(defaultOption);
                };

                // If this dropdown includes the most on brand sorting option
                // send a GA event with the current sorting option.
                // This is used to compare most on-brand sort usage in comparison to other sorting methods.
                this.trackOnBrandSort = function(sortOrder) {
                  // Dropdown locations that include the on-brand option:
                  const isFanreelModerationSort = $scope.trackingCategory === 'FanreelModeration' && $scope.name === 'moderation-order';

                  if (isFanreelModerationSort) {
                    const gaLabel = getSortLabel(sortOrder.toLowerCase());

                    if (gaLabel) {
                      TrackingService.recordEvent(
                        TrackingService.CATEGORY_DROPDOWN_WITH_ON_BRAND,
                        TrackingService.ACTION_DROPDOWN_WITH_ON_BRAND_SORT,
                        gaLabel,
                      );
                    }
                  }
                };

                this.checkSelectOptionNameChanged = function(newName, oldName) {
                  if ($scope.selectedOption.name === oldName) {
                    $scope.selectedOption.name = newName;
                  }
                };

                this.selectOption = function(option) {
                  if ($scope.selectedOption.value === option.value) {
                    return; // The user is attempting to select the option that's already selected. IGNORE.
                  }

                            // Update internal state
                  $scope.selectedOption = option;

                            // Invoke callback function in parent scope
                  $scope.optionChange({ value: option.value });

                            // If caller has passed a tracking category then let's use it to log an event to GA
                  if ($scope.trackingCategory && $scope.trackingCategory.length > 0) {
                    TrackingService.recordEvent($scope.trackingCategory, TrackingService.ACTION_SELECT_DROPDOWN, option.value);
                  }

                  this.trackOnBrandSort(option.value);
                };

                this.registerOption = function(option) {
                  $scope.options.push(option);
                  if (
                                ((!$scope.selectedOption || $scope.model.dynamicDefault) &&
                                    $scope.default && $scope.default === option.value) || // 'default' value is defined
                                (!$scope.selectedOption && !$scope.default) // 'default' value is not defined
                            ) {
                    $scope.selectedOption = option;
                  }
                };

                if ($scope.name) {
                  $scope.$on(`dropdown:${$scope.name}:resetDropdownToDefault`, ($event, force) => {
                    const optionToSet = _($scope.options).findWhere({ value: force ? $scope.default : defaultOption });
                    if (optionToSet) {
                      that.selectOption(optionToSet);
                    }
                  });

                  $scope.$on(`dropdown:${$scope.name}:changeOption`, ($event, args) => {
                    const optionToSet = _($scope.options).findWhere({ value: args.value });

                    if (optionToSet) {
                      that.selectOption(optionToSet);
                    }
                  });
                }

                        // Used to account for the case where all options are registered, but the $scope.default value hasn't been resolved yet.
                if ($scope.lazyDefault === 'true') {
                  $timeout(() => {
                    const option = _($scope.options).findWhere({ value: $scope.default });

                    if (option) {
                      $scope.selectedOption = option;
                    }
                  });
                }
              }],
              link(scope, element, attrs) {
                let highlightedOptionIdx;
                let searchText = ''; // The text to search against in the dropdown
                const fullWidth = angular.isDefined(attrs.fullWidth);
                const dynamicDefault = angular.isDefined(attrs.dynamicDefault);

                scope.withUnison = !!element.closest('.unison-component').length;

                if (fullWidth) {
                  element.find('.dropdown').addClass('full-width-dropdown');
                }

                if (dynamicDefault) {
                  scope.model.dynamicDefault = true;

                  scope.$watch('default', (newVal, oldVal) => {
                    let option;
                    if (!angular.equals(newVal, oldVal)) {
                      option = _(scope.options).findWhere({ value: newVal });
                      if (option) {
                        scope.selectedOption = option;
                        scope.optionChange({ value: option.value });
                      }
                    }
                  });
                }

                const scheduleClearSearchText = _.debounce(() => {
                  searchText = '';
                }, 500);

                const clearHighlightedOption = function() {
                  if (highlightedOptionIdx) {
                    scope.options[highlightedOptionIdx].unhighlight();
                    highlightedOptionIdx = null;
                    searchText = '';
                  }
                };

                const onKeypress = function(event) {
                  const char = String.fromCharCode(event.charCode);
                  let matchedIdx;
                  let i;

                  if (event.keyCode === ENTER_KEY) {
                                // If an option is highlighted and the user hits the enter key, then select the highlighted option
                    if (highlightedOptionIdx) {
                      element.find('.dropdown-menu li').get(highlightedOptionIdx).click();
                    }
                    return;
                  }

                            // Append new character to the search string
                  searchText += char;

                  for (i = 0; i < scope.options.length; i++) {
                    if (scope.options[i].name.toLowerCase().indexOf(searchText) === 0) { // found an option that starts with search text
                      matchedIdx = i;
                      break;
                    }
                  }

                  if (highlightedOptionIdx && matchedIdx !== highlightedOptionIdx) {
                                // unhighlight existing selected option
                    scope.options[highlightedOptionIdx].unhighlight();
                  }

                  if (matchedIdx && matchedIdx !== highlightedOptionIdx) {
                                // if we found a match, record it and notify the option that it should be highlighted.  We
                                // also scroll to the highlighted option.
                    highlightedOptionIdx = matchedIdx;
                    scope.options[matchedIdx].highlight();
                    element.find('.dropdown-menu').scrollTop(OPTION_HEIGHT_PX * matchedIdx);
                  }

                            // Schedule the search text to be cleared after a certain amount of inactivity.
                  scheduleClearSearchText();
                };

                        // Set up typeahead search functionality if 'height' is defined.  Without a height defined, the dropdown
                        // is not scrollable and thus the typeahead functionality is not able to function.
                if (scope.height) {
                            // Highlight text match after a keypress
                  element.keypress(onKeypress);

                            // To emulate a 'select' element we need to clear out the highlighted option if the mouse moves
                  element.find('.dropdown-menu').mousemove(clearHighlightedOption);

                            // This is the same method that Bootstrap uses to determine when a dropdown should be hidden
                  $('html').on('click.dropdown.data-api', clearHighlightedOption);
                }
              },
            }),
        );
})();
